<template>
    <div v-if="!showMenu & showMenu != 'undefined'">

       
        <div class="kingster-top-bar">
            <div class="kingster-top-bar-background"></div>
            <div class="kingster-top-bar-container kingster-container ">
                <div class="kingster-top-bar-container-inner clearfix">
                    <div class="kingster-top-bar-right kingster-item-pdlr">
                    
                    </div>
                </div>
            </div>
        </div>

      
        <header
              data-navigation-offset="60px" class="navbar-fixed-top fixed-top" fixed="top">
          
           
            <div class="topHeader">
                <div class="container">
                     <a href="http://abr.su.edu.eg/" target="_blank" class="small"> <b-icon icon="building" class=" rounded text-center"></b-icon> Arish Self-Services</a>
                    <a href="http://unicodesis.su.edu.eg" target="_blank" class="small">  <b-icon icon="building" class=" rounded text-center"></b-icon> Kantara Self-Services</a>
                    <a href=""  @click.prevent="logOut" class="small float-right"> <b-icon-lock-fill></b-icon-lock-fill> Logout </a>
                    <a href="/Profile"  class="small float-right">  <b-icon icon="person-circle" class=" rounded text-center"></b-icon> {{currenUser ? currenUser.FirstNameEN : ''}} {{currenUser? currenUser.LastNameEN : ''}}</a>   

            </div>
        
        
        
        
        </div>    
                

<b-navbar toggleable="lg" type="dark" variant="info" >
    <div class="container">
  <b-navbar-brand href="#"><a class="" href="http://sinaiuniversity.net/">
    <b-icon icon="house-fill" class=" rounded text-center"></b-icon> SINAI UNIVESRSITY
    <!-- <img
                                    src="./../assets/logo-2.png" alt="" width="137"
                                    height="95" title="logo 2"> -->
                                
                                </a></b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      
      <b-navbar-nav class="ml-auto mt-4" right  v-if="!currenUser.LoginInfo">
      
        <b-nav-item href="/home" >Home</b-nav-item>
        <b-nav-item href="/dataapp" to="">Data</b-nav-item>
        <b-nav-item href="/Wallet" to="">Wallet</b-nav-item>
        <b-nav-item href="/Exams" to="">Exams</b-nav-item>
        <b-nav-item href="/Tasks" to="">Tasks</b-nav-item>
        <b-nav-item href="/Mail" to="">Inbox</b-nav-item>
        <b-nav-item href="/Profile" to="">Profile</b-nav-item>
        <!-- <b-nav-item href="http://unicodesis.su.edu.eg" target="_blank">Kantara Self-Services</b-nav-item> -->
        <!-- <b-nav-item href="https://kmoodle.su.edu.eg/" target="_blank">SU LMS</b-nav-item> -->
        
      </b-navbar-nav>

     
    </b-collapse>    </div>
  </b-navbar>

              
                  
        
            
        </header>
    </div>






</template>

<script>
    export default {
        name:'Header',
        data() {
            return {
               ShowMenu:true
            }
        },


        computed: {
            currenUser() {
                return this.$store.state.auth.user
            },
            showMenu(){
                 return this.$store.state.auth.Menuhide
            }
        },
        mounted() {
        this.showMenu
        },
        methods: {
            logOut() {
         this.$store.dispatch('auth/logout');
         this.$router.push('/login');
         
    },
    Menu(){
        this.showMenu
    }
        }
    }
</script>

<style scoped>
.kingster-logo-inner{
    width: 25%;
    float: left;
    
}
.kingster-top-bar{
    background: #295677;
    color: 333;
    padding: 20px;
}
header{
    background: #fff;
   
      width: 100%;
      z-index: 1000;
}

.sf-menu > li {
    float: left;
    cursor: pointer;
    padding-right: 39px;
    padding-top: 30px;
    color: #295677;
    list-style: none;
    float: right;
}
.sf-menu > li a {
    color: #295677;
    font-weight: bold;
}

.sf-menu {
    display: inline-block;
    line-height: 1.7;
    text-align: left;
    margin-bottom: 0px;
    margin-right: 20px;
    float: right;
}
.kingster-header-container {
    position: relative;
    margin-left: auto;
    margin-right: auto;
    width: 90%;
    margin: 0 auto;
}

@media only screen and (max-width: 1260px){
.kingster-top-bar {
     display:block; 
}
}

.navbar {
    float: right !important;
        color: #ffffff;
           
    background: #072D6C;
   
      width: 100%;
      z-index: 1000;
      /* border-top:25px #295677 solid; */
      padding: 0px;
     
         
}
.navbar-dark .navbar-nav .nav-link {
     color: #fff;
     font-weight: bold;
      padding-bottom: 44px
}

.navbar-dark .navbar-nav .nav-link:hover {
     color: #295677;
     border-bottom: 5px solid #295677 ;
     border-width: 90%;
     transition: left .3s ease-in-out;
-webkit-transition: left .3s ease-in-out;
transition: left linear 0.25s, right linear 0.25s;
  
     
     
}
.navbar-dark .navbar-nav .nav-link:visited {
     color: #fff !important;
     border-bottom: 5px solid #295677 ;
     border-width: 90%;
     
     
}
.navbar-dark .navbar-nav .nav-link.active {
     color: #fff !important;
     border-bottom: 5px solid #295677 ;
     border-width: 90%;
     
     
}
.bg-info {
    color: #ffffff;
           
   background: #072D6C;
    background-color: #072D6C !important;
    border-bottom: 1px solid #dddcdc;
}
.bg-info a {
    color: #ffffff;
}
.navbar-toggler {
    padding: 0.25rem 0.75rem;
    font-size: 1.25rem;
    line-height: 1;
    background-color: #295677;
    border: 1px solid transparent;
    border-radius: 0.25rem;
}
@media (min-width: 1200px){

.container, .container-sm, .container-md, .container-lg, .container-xl {
    max-width: 90% !important;
}
}
@media (max-width: 680px){
.navbar{
    float: right !important;
    color: #ffffff;
           
           background: #072D6C;
    width: 100%;
    z-index: 1000;
    /* border-top: 10px #295677 solid; */
}
}
</style>